import { IconButton } from '@mui/material';
import React, { Component } from 'react'
import { FaBan, FaCheck, FaEdit } from 'react-icons/fa';
import { AUTH_TOKEN } from '../../constants'
import Accordion from 'react-bootstrap/Accordion'
import Modal from 'react-bootstrap/Modal';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import 'bootstrap/dist/css/bootstrap.css';


class Label extends Component {
  state = {
    title: '',
    accepted_categorization: false,
    categories: [],
    subcategories: [],
    skills: [],
    subskills: [],
    all_categories: [],
    show: false
  }

  constructor(props) {
    super(props);
    // Don't call this.setState() here!
    if(props.label !== undefined && props.categories !== undefined) {
        this.state = { 
            title: props.label.title,
            accepted_categorization: props.label.accepted_categorization,
            categories: props.label.categories,
            subcategories: props.label.subcategories,
            skills: props.label.skills,
            subskill: props.label.subskill,
            all_categories: props.categories
        };
    } 
    this.cleanState  = this.cleanState.bind(this)
  }

  selectNounce(nounce) {


  }

  updateCategory(nouncetree) {

  }

  cleanState() {
    this.setState({
        title: '', 
        accepted_categorization: false,
        categories: [],
        subcategories: [],
        skills: [],
        subskills: [],
    })
  }


  
  NounceAccordion(nounces, selectedCategories) {
    // let selectedNounce;
    // if(selectedNounces != null) {   
    //   for(let i = 0; i < nounces.length; i++) {
    //     let nounce = nounces[i]
    //     if(selectedNounces.code === nounce.code) {
    //       selectedNounce = nounce
    //       break
    //     }
    //   }
    // }
    let codes = selectedCategories != null ? selectedCategories.map(element => element.code) : []
    return (
      <Accordion defaultActiveKey={codes} alwaysOpen> {
        nounces.map((nounce, i) => {
            // let children = nounce.subcategories != null && nounce.subcategories.length > 0 ? nounce.subcategories
            //                : nounce.skills != null && nounce.skills.length > 0 ? nounce.skills
            //                : nounce.subskills != null && nounce.subskills.length > 0 ? nounce.subskills : []
            // let hasSub = children != null && children.length > 0
            return (
        <Accordion.Item key={nounce.code} eventKey={nounce.code} >
            <Accordion.Header onClick={(param) => {
              let updated = false
              let updatedCategories = []
              for(let i = 0; i < selectedCategories.length; i++) {
                if(selectedCategories[i].code === nounce.code) {
                  updated = true
                  console.log(`removed ${nounce.code}`)
                  continue
                }
                updatedCategories.push(selectedCategories[i])
              }
              if(!updated) {
                updatedCategories.push(nounce)
                console.log(`Selected ${nounce.code}`)
              }
              this.setState({categories: updatedCategories})
            }}
            >{this.createNames(nounce)
            }</Accordion.Header>
            {/* {children && hasSub && 
            (<Accordion.Body>
                {this.NounceAccordion(children, [])}
            </Accordion.Body>)} */}
        </Accordion.Item>
        )})
    }
      </Accordion>
    );
  }

  PopupButton(selectedCategories) {  
    return (
      <div>
        <IconButton onClick={e => { this.setState({show: true})}}><FaEdit/></IconButton>
  
        <Modal
          show={this.state.show}
          onHide={() => this.setState({show: false})}
          dialogClassName="modal-90w"
          aria-labelledby="example-custom-modal-styling-title"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-custom-modal-styling-title">
              Set right Nounce number
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
              {this.state.show ? this.NounceAccordion(this.state.all_categories, selectedCategories) : ""}
          </Modal.Body>
        </Modal>
      </div>
    );
  }

  createNames(nance) {
     return(<div>{`${nance.code} ${nance.title}`}</div>)
  }
  
  getCategories(token, categories) {
    return (
    token && !this.props.locked ?
    <div>
        <div>
          <Row>
            <Col xs={9} style={{}}>{
              categories.map((category, i) => <div key={i}>
                  <div>{this.createNames(category)}</div>
              </div>)
            }</Col>
         <Col xs={2} style={{}}>{this.PopupButton(categories)}</Col>
        </Row>
        </div>
    </div>
    : <div style={{
        textAlign: "left"
    }}>{categories.map((category, i) => <div key={i}>{this.createNames(category)}</div>)}</div> )
  }
 
  render() {
    const token = localStorage.getItem(AUTH_TOKEN)

    let label = this.props.label !== undefined ? this.props.label : {id: '', titel: '', accepted_categorization: false}
    
    let elements = React.Children.toArray(this.props.children)
    let addButton
    let deleteButton
    let updateButton
    if(elements.length === 1)
        addButton = React.cloneElement(elements[0], {state: this.state, cleanState: this.cleanState})
    if(elements.length === 2){
        deleteButton = React.cloneElement(elements[0], {id: this.props.label.id})
        updateButton = React.cloneElement(elements[1], {id: this.props.label.id, state: this.state, cleanState: this.cleanState})
    }

    return (
        <tr className={this.state.accepted_categorization ? "tableApproved" : ""}>
            <td>{label.id}</td>
            <td>{
                token && !this.props.locked ?
                <input
                value={this.state.title}
                onChange={e => this.setState({title: e.target.value})}
                type="text"
                placeholder="Label Title"
                /> 
                : 
                <div>{label.title}</div> 
            }</td>
            <td>{
                token && !this.props.locked ?
                <div style={{ display: 'block', width: 200}}>
                    <Row>
                        <Col><div style={{
                            textAlign: "center",
                        }}>{label.accepted_categorization ? "true" : "false"}</div></Col>
                        <Col><div>
                            <IconButton onClick={e => {
                                this.setState({
                                    accepted_categorization: !this.state.accepted_categorization
                                })
                            }}>{this.state.accepted_categorization ? <FaBan/> : <FaCheck/>}</IconButton>
                        </div></Col>
                    </Row>
                </div>
                : <div style={{
                    width: 200,
                    textAlign: "center"
                }}>{label.accepted_categorization ? "true" : "false"}</div> 
            }</td>
            {/* categories */}
            <td>{
                this.getCategories(token, this.state.categories)
            }</td>
            {token && !this.props.locked && this.props.label === undefined  && addButton !== undefined &&
            <td>{ addButton }</td>}
            {token && !this.props.locked && this.props.label !== undefined  && updateButton !== undefined &&
            <td>{ updateButton }</td>}
            {token && !this.props.locked && this.props.label !== undefined  && deleteButton !== undefined &&
            <td>{ deleteButton }</td>}
        </tr>
        )
    };
}
    

export default Label